module.exports = __webpack_public_path__ + "static/media/certificate-enrolled-1-4.3c6c0e8d.svg";